import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../components/SocketContext';
import { useLocation } from 'react-router-dom';
import { loadSpriteSheet } from '../helpers/SpriteUtil';
import ConfettiExplosion from 'react-confetti-explosion';
import OverLay from '../components/Overlay';

import { useReward } from 'react-rewards';
let playerName = null;

const Test = (props) => {
    const socket = useContext(SocketContext);
    const [sprites, setSprites] = useState([]);
    const { reward, isAnimating } = useReward('rewardId', 'emoji', {lifetime: 100});
    let navigateData = useLocation();

    useEffect(() => {

        if (sprites.length === 0) {
            loadSpriteSheet('bigfaces3.png', 275, 375, 3, 3).then((sprites) => {
                setSprites(sprites);
            });
        }

        if (socket) {
        }

        return () => {
            if (socket) {
                //socket.off('isdrawing');
            }
        };

    }, [socket]);

    return (
        <>
           <h1>Test</h1>

            <div class="parent">
                
                <div class="div1">
                    <img src="littleguy.png" height="75px" alt="Cute baby holding a crayon" style={{ float: "left" }} />
                    <img src={sprites[0]} height="70" id="test" role="button" onClick={reward} />
                    <button disabled={isAnimating} onClick={reward}>🎉</button>
                </div>
                <div class="div2">

                </div>
                <div class="div3">
                    &nbsp;
                </div>
                <div class="div4">

                </div>
                <div class="div5">
                    <div id="overlay" className="overlay" style={{ zIndex: 5 }}>
                        <div className="overlay-content">
                        <span id="rewardId" ><h4>Winner</h4></span>
                            <p>Bean</p>
                        </div>
                    </div>
                    

                </div>
                <div class="div6">

                </div>
                <div class="div7">
                    &nbsp;
                </div>
                <div class="div8">

                </div>
                <div class="div9">
                    &nbsp;
                </div>
            </div>
        </>
    );
};

export default Test;